import {AfterViewInit, Component, Inject, ViewChild} from '@angular/core';
import { VentanaFlotante } from '../models/VentanaFlotante';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource, MatTableDataSourcePaginator} from "@angular/material/table";
import { MatPaginator} from "@angular/material/paginator";

@Component({
  selector: 'ral-listado-comentarios',
  templateUrl: './listado-comentarios.component.html',
  styleUrls: ['./listado-comentarios.component.scss']
})
export class ListadoComentariosComponent extends VentanaFlotante implements AfterViewInit{
  datos: any[] = [];
  columns: any[] = [];
  dataSource = new MatTableDataSource(this.datos);

  constructor(
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: { datos: any[] , columns: any[]},
  ) {
    super(dialogRef, data);
    this.datos = data.datos;
    this.columns = data.columns;
  }

  @ViewChild(MatPaginator) paginator: MatTableDataSourcePaginator | null = null;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {
    this.dataSource.data = this.datos;
  }

  onPageChange(event: any) {
    if (this.paginator)
      this.paginator.pageIndex = event.pageIndex;
  }
}
